/**
 * Determine which images should be loaded for smooth transitions
 */
export function shouldLoadImage(
  imageIndex: number,
  currentIndex: number,
  totalSlides: number,
  infinite = false
): boolean {
  // Always load current image
  if (imageIndex === currentIndex) {
    return true;
  }

  // Load adjacent images for smooth transitions
  const isPrevSlide = infinite
    ? imageIndex === (currentIndex - 1 + totalSlides) % totalSlides
    : imageIndex === currentIndex - 1;

  const isNextSlide = infinite
    ? imageIndex === (currentIndex + 1) % totalSlides
    : imageIndex === currentIndex + 1;

  return isPrevSlide || isNextSlide;
}

/**
 * Calculate next slide index based on navigation direction
 */
export function calculateNextIndex(
  currentIndex: number,
  direction: number,
  totalSlides: number,
  infinite = false
): number | null {
  const nextIndex = currentIndex + direction;

  if (infinite) {
    return (nextIndex + totalSlides) % totalSlides;
  }

  if (nextIndex >= 0 && nextIndex < totalSlides) {
    return nextIndex;
  }

  return null;
}

/**
 * Determine if drag gesture should trigger navigation
 */
export function calculateDragNavigation(
  dragDistance: number,
  threshold = 50
): { shouldNavigate: boolean; direction: number } {
  const absDist = Math.abs(dragDistance);

  return {
    shouldNavigate: absDist > threshold,
    direction: dragDistance > 0 ? 1 : -1, // positive = next, negative = prev
  };
}
